import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BlobProvider } from '@react-pdf/renderer';
import React from 'react';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap';
import ButtonIcon from '../../components/common/ButtonIcon';
import SolicitudFormato from './formato/SolicitudFormato';

const SuccessModal = ({ open, data, onOk }) => {
    const fileName = `solicitud_credito_${data?.numeroSolicitud || ''}.pdf`;

    return (
        <Modal size="lg" isOpen={open}>
            <ModalHeader>
                <h5>Solicitud de Crédito</h5>
                <span className="text-primary" style={{ fontSize: '0.8em' }}>
                    {data?.numeroSolicitud ? `Solicitud ${data.numeroSolicitud}` : ''}
                </span>
            </ModalHeader>
            <ModalBody className="p-3">
                <div className="text-center mt-4">
                    <FontAwesomeIcon icon="check" transform="shrink-2" className="text-success mr-1 fs-8" />
                    <h6 className="fs-2 m-3">Solicitud Creada!</h6>
                    <p className="fs--1">
                        Imprima el formato, complete a mano la liquidación y las declaraciones,
                        y recójalo firmado por el cliente.
                    </p>
                    {data && (
                        <BlobProvider document={<SolicitudFormato data={data} />}>
                            {({ url, loading, error }) => {
                                if (loading) {
                                    return (
                                        <span className="fs--1">
                                            <Spinner size="sm" color="primary" className="mr-2" />
                                            Generando formato...
                                        </span>
                                    );
                                }
                                if (error) {
                                    return <span className="fs--1 text-danger">No se pudo generar el formato</span>;
                                }
                                return (
                                    <div>
                                        {/* Enlace y no window.open: el navegador puede bloquear la
                                            ventana emergente sin avisar y el botón queda muerto. */}
                                        <ButtonIcon
                                            color="falcon-default"
                                            size="sm"
                                            icon="print"
                                            className="mr-2 mb-2 mb-sm-0"
                                            tag="a"
                                            href={url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Ver e imprimir
                                        </ButtonIcon>
                                        <ButtonIcon
                                            color="falcon-default"
                                            size="sm"
                                            icon="arrow-down"
                                            className="mr-2 mb-2 mb-sm-0"
                                            tag="a"
                                            href={url}
                                            download={fileName}
                                        >
                                            Descargar formato
                                        </ButtonIcon>
                                    </div>
                                );
                            }}
                        </BlobProvider>
                    )}
                </div>
            </ModalBody>
            <ModalFooter className="no-border">
                <Col className="text-right">
                    <Button onClick={onOk} transform="shrink-3 down-2" color="primary">
                        Aceptar
                    </Button>
                </Col>
            </ModalFooter>
        </Modal>
    );
};

export default SuccessModal;
